"use client";

import styles from "./AuthorizeHeroBanner.module.scss";
import { Flex } from "@vetty/ui";

// Marketing feature points displayed on desktop
const POINTS = [
  {
    label: "Improve your anatomy skills with realistic models",
    iconUrl: "/assets/award-icon.svg",
  },
  {
    label: "Use Vetty anytime on desktop or tablet",
    iconUrl: "/assets/tablet-icon.svg",
  },
  {
    label: "Collaborate with the community to enhance learning",
    iconUrl: "/assets/message-square-icon.svg",
  },
];

/**
 * AuthorizeHeroBanner Component
 *
 * Desktop marketing banner with value propositions and feature highlights.
 * Only visible on desktop/laptop screens to promote the platform benefits.
 */
export const AuthorizeHeroBanner = () => {
  return (
    <div className={styles["comp"]}>
      {/* Main headline with call-to-action */}
      <h1 className={styles["comp__header"]}>
        Continue your <span>learning journey with Vetty</span> and explore 3D
        veterinary anatomy with ease.
      </h1>

      {/* Feature points list */}
      <Flex direction={"column"} gap={20} className={styles["comp__features"]}>
        {POINTS.map((p) => (
          <Flex
            key={p.label}
            align={"center"}
            gap={12}
            className={styles["comp__features__item"]}
          >
            {/* Feature icon */}
            <img
              className={styles["comp__features__item__icon"]}
              src={p.iconUrl}
            />

            {/* Feature description */}
            <div
              className={styles["comp__features__item__label"]}
              dangerouslySetInnerHTML={{ __html: p.label }}
            />
          </Flex>
        ))}
      </Flex>
    </div>
  );
};
